<app-breadcrumb *ngIf="!dialogRef" [master]="'Rejestracje'" [parentName]="'Wymogi IDD'" [name]="'Dodaj'"></app-breadcrumb>
<div class="certificate-add" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" *ngIf="!dialogRef">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!certificateFormValid  || processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div [fxFlex]="dialogRef ? '100' : '50'" fxLayout="column" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Dane zaświadczenia</h3>
        </div>

        <app-file-drag-and-drop [multiple]="false" [fileControl]="fileControl"></app-file-drag-and-drop>

        <div fxLayout="row" *ngIf="!iddTrainingObject">
          <app-dict-ofwcas
            fxFlex="100"
            label="OFWCA"
            [control]="ofwcaControl"
            [required]="true"
            (selectedOfwca)="ofwcaChanged($event)"
          ></app-dict-ofwcas>
        </div>

        <div fxLayout="row" style="margin-bottom: 15px" *ngIf="iddTrainingObject">
          <app-detail fxFlex="100" header="Szkolenie IDD">
            IDD {{iddTrainingObject.year}} {{iddTrainingObject.ofwca.fullName}}
          </app-detail>
        </div>

        <div fxLayout="row" *ngIf="!iddTrainingObject">
          <mat-form-field style="width: 100%">
            <mat-label>Szkolenie IDD</mat-label>
            <mat-select [formControl]="iddTrainingControl" [required]="true">
              <mat-option *ngFor="let iddTraining of iddTrainings" [value]="iddTraining.uuid">
                IDD {{iddTraining.year}} {{iddTraining.ofwca.fullName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>


        <div fxLayout="row">
          <app-dict fxFlex="100" dictType="meeting_leader" label="Organizator"
                    [required]="true" [control]="meetingLeaderControl" (selectedDict)="meetingLeaderChanged($event)"></app-dict>
        </div>

        <div fxLayout="row" *ngIf="insuranceCompanyControl.enabled">
          <app-dict-insurance-companies fxFlex="100" label="TU" [required]="true" [control]="insuranceCompanyControl"
                                        [hideChildren]="true" (selectedInsuranceCompany)="insuranceCompanyChanged($event)"
                                        [skipKeys]="[IC_WARTA,IC_GENERALI,IC_GENERALI_LIFE,IC_WARTA_LIFE]"
          ></app-dict-insurance-companies>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field fxFlex="100">
              <mat-label>Majątek - godziny</mat-label>
              <input autocomplete="off" [required]="false" type="number" matInput placeholder="Liczba minut - majątek" [formControl]="realisedAssetsHoursPartControl">
            </mat-form-field>
          </div>

          <div fxFlex="50">
            <mat-form-field fxFlex="100">
              <mat-label>Majątek - minuty</mat-label>
              <input autocomplete="off" [required]="false" type="number" matInput placeholder="Liczba minut - majątek" [formControl]="realisedAssetsMinutesPartControl">
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field fxFlex="100">
              <mat-label>Życie - godziny</mat-label>
              <input autocomplete="off" [required]="false" type="number" matInput placeholder="Liczba minut - życie" [formControl]="realisedLifeHoursPartControl">
            </mat-form-field>
          </div>

          <div fxFlex="50">
            <mat-form-field fxFlex="100">
              <mat-label>Życie - minuty</mat-label>
              <input autocomplete="off" [required]="false" type="number" matInput placeholder="Liczba minut - życie" [formControl]="realisedLifeMinutesPartControl">
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field fxFlex="100">
              <mat-label>Ogólne - godziny</mat-label>
              <input autocomplete="off" [required]="false" type="number" matInput placeholder="Liczba minut - ogólne" [formControl]="realisedGeneralHoursPartControl">
            </mat-form-field>
          </div>

          <div fxFlex="50">
            <mat-form-field fxFlex="100">
              <mat-label>Ogólne - minuty</mat-label>
              <input autocomplete="off" [required]="false" type="number" matInput placeholder="Liczba minut - ogólne" [formControl]="realisedGeneralMinutesPartControl">
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <app-datepicker
              label="Data szkolenia"
              placeholder="2000-01-01 00:00"
              [required]="true"
              [control]="realisedAtControl"
            ></app-datepicker>
          </div>

          <div fxFlex="50">
            <div fxLayout="row">
              <mat-slide-toggle color="accent" [formControl]="amlControl">AML</mat-slide-toggle>
            </div>
          </div>

        </div>

      </mat-card>

      <div fxLayout="row">
        <div fxLayout="row" fxLayoutGap="15px">
          <button (click)="save()" [class.spinner]="processingRequest"
                  [disabled]="!certificateFormValid || processingRequest"
                  mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
          <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
        </div>
      </div>
    </div>

    <div *ngIf="!dialogRef && selectedIddTraining" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Zaświadczenia - {{selectedOfwca?.fullName}}</h3>
        </div>

        <div fxLayout="row wrap">
          <div fxFlex="50" *ngFor="let certificate of (selectedIddTraining.certificates | orderIddCertificates)">
            <div class="certificate-image">
              <img
                (click)="certificateOverview(certificate)"
                (error)="onCertImgError($event)"
                [alt]="certificate.realisedAt | date:'y-MM-dd'"
                [src]="'/rest/crm/idd-training-certificate/' + certificate.uuid + '/image'"
              />

              <div class="certificate-details" (click)="certificateOverview(certificate)">
                <span class="type-header">Organizator: </span>
                <span>{{certificate.meetingLeader?.name}}</span><br>
                <ng-container *ngIf="certificate.insuranceCompany">
                  <span class="type-header">TU: </span>
                  <span>{{certificate.insuranceCompany?.name}}</span><br>
                </ng-container>
                <span class="type-header">Data szkolenia: </span>
                <span>{{certificate.realisedAt | date:'y-MM-dd'}}</span><br>
                <span class="type-header">Majątek: </span>
                <span>{{(floor(certificate.realisedAssetsMinutes / 60).toString() | number:'1.0-0') + 'h'}} {{(floor(certificate.realisedAssetsMinutes % 60).toString() | number:'1.0-0') + 'min'}}</span><br>
                <span class="type-header">Życie: </span>
                <span>{{(floor(certificate.realisedLifeMinutes / 60).toString() | number:'1.0-0') + 'h'}} {{(floor(certificate.realisedLifeMinutes % 60).toString() | number:'1.0-0') + 'min'}}</span><br>
                <span class="type-header">Ogólne: </span>
                <span>{{(floor(certificate.realisedGeneralMinutes / 60).toString() | number:'1.0-0') + 'h'}} {{(floor(certificate.realisedGeneralMinutes % 60).toString() | number:'1.0-0') + 'min'}}</span><br>
                <span class="type-header">AML: </span>
                <span>{{certificate.aml? 'TAK' : 'NIE'}}</span><br>

              </div>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
